/**
 * The vendor categories highlighted on the home page and in the footer, per
 * market. Slugs match vendor_categories.slug on the API (see
 * App\\Support\\VendorCategoryCatalog).
 */
import { MARKET } from '@utils/market';

const GLOBAL = [
  { slug: 'photographer', icon: '📷', key: 'categories.photography' },
  { slug: 'videographer', icon: '🎬', key: 'categories.videography' },
  { slug: 'caterer', icon: '🍽️', key: 'categories.catering' },
  { slug: 'florist', icon: '💐', key: 'categories.florists' },
  { slug: 'dj', icon: '🎵', key: 'categories.musicDjs' },
  { slug: 'planner', icon: '📋', key: 'categories.weddingPlanners' },
  { slug: 'hair_makeup', icon: '💄', key: 'categories.makeupHair' },
  { slug: 'bakery', icon: '🎂', key: 'categories.cakesDesserts' },
];

const INDIA = [
  { slug: 'photographer', icon: '📷', key: 'categories.photography' },
  { slug: 'caterer', icon: '🍽️', key: 'categories.catering' },
  { slug: 'mehndi_artist', icon: '🌿', key: 'categories.mehndiArtists' },
  { slug: 'pandit', icon: '🪔', key: 'categories.pandits' },
  { slug: 'mandap_decor', icon: '⛺', key: 'categories.mandapDecor' },
  { slug: 'bridal_wear', icon: '👰', key: 'categories.bridalWear' },
  { slug: 'hair_makeup', icon: '💄', key: 'categories.makeupHair' },
  { slug: 'baraat_band', icon: '🥁', key: 'categories.baraatBands' },
];

export const featuredVendorCategories = (market = MARKET) => (market === 'india' ? INDIA : GLOBAL);
